import { Account, UserLegalInfoField } from './types';

export const getMissingUserLegalInfoFields = ({ company, user }: Account): UserLegalInfoField[] => {
  if (company.taxInfo?.type === 'EIN' || user.dateOfBirth) {
    return [];
  }

  return ['dateOfBirth'];
};
